import { jsx } from 'react/jsx-runtime';

const SvgMiscBoltFill = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M12 22c5.51 0 10-4.49 10-10S17.51 2 12 2 2 6.49 2 12s4.49 10 10 10Zm1-16v5h3l-5 7v-5H8l5-7Z" }) }));

export { SvgMiscBoltFill as default };
//# sourceMappingURL=MiscBoltFill.es.js.map
